<template>
  <div>
      <!-- Pastille d'information -->
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">

            <div v-if="organizationData.subscription" class="col-sm-12 col-md-12">
              <hr size="50">

              <div class="col-sm-6 col-md-6">
                <h2 class="block-title">{{ textLabelLastPaimentDate[actualLanguage] }}{{organizationData.subscription.data.renewalLastDate}}</h2>
              </div>

              <div class="col-sm-6 col-md-6 push">
                <h2 class="block-title">{{ textLabelNextPaimentDate[actualLanguage] }}{{organizationData.subscription.data.renewalDate}}</h2>
                <label class="css-input switch switch-success">
                    <input @click="automaticRenewButtonSwitch()" type="checkbox" checked v-model="organizationData.subscription.data.automaticRenewFlag"><span></span> <span class="h5 font-w400">{{ buttonLabelAutomaticRenewal[actualLanguage] }}</span>
                </label>

                <label class="css-input switch switch-success">
                    <input @click="automaticRenewButtonSwitch()" type="checkbox" checked v-model="organizationData.subscription.data.preAuthorizedPaymentFlag"><span></span> <span class="h5 font-w400">{{ buttonLabelAutomaticPreAuthorizedPaiement[actualLanguage] }}</span>
                </label>


                <div v-if="renewFlagModified">
                  <p><button @click="modifyMyAutomaticRenew()" type="button" class="btn btn-success align-center" name="button">{{ buttonLabelSaveModification[actualLanguage] }}</button></p>
                </div>
              </div>

              <!-- ================================================================= -->
              <!-- Affichage des informations de la carte de crédit -->
              <!-- ================================================================= -->
              <div v-if = "(organizationData.subscription.data.preAuthorizedPaymentFlag) && (organizationData.subscription.data.automaticRenewFlag)" class="col-sm-12 col-lg-12">

                  <div v-if="(organizationData.subscription.data.paymentType=='CreditCardStripe')" class="block block-bordered">
                      <div class="block-header bg-gray-lighter">
                          <h2 class="block-title">{{ sectionLabelCreditCard[actualLanguage] }}</h2>
                      </div>
                      <div class="block-content">
                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <i class="fa fa-credit-card fa-2x"></i>
                          <span class="h4 font-w400">{{organizationData.subscription.data.creditCardBrand}}</span>
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <span class="h4 font-w400">{{ textLabelCardLastDigit[actualLanguage] }}{{organizationData.subscription.data.creditCardLastDigit}}</span>
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <span class="h4 font-w400">Expire:{{organizationData.subscription.data.creditCardExpMonth}}/{{organizationData.subscription.data.creditCardExpYear}}</span>
                        </div>

                        <div class="row">
                          <!--
                            //RETRAIT STRIPE
                            <div class="col-sm-3 col-md-3">
                              <p><button @click="modifyMyCreditCard()" type="button" class="btn btn-success align-center" name="button">{{ buttonLabelModifyCard[actualLanguage] }}</button></p>
                            </div>
                            -->
                        </div>

                      </div>
                  </div>

                  <!-- -------------------------------------- -->
                  <!-- Section qui demande d'enregistrer une carte de crédit -->
                  <!-- -------------------------------------- -->
                  <div v-if = "(organizationData.subscription.data.preAuthorizedPaymentFlag) & (organizationData.subscription.data.paymentType=='ManuallyBilled')" class="col-sm-12 col-lg-12">
                          <span class="h4 font-w400">{{textYouMustRegisterCreditCard[actualLanguage]}}</span>

                          <div class="row">
                              <div class="col-sm-3 col-md-3">
                                <p><button @click="applyCreditCard()" type="button" class="btn btn-success align-center" name="button">{{ buttonLabelApplyCard[actualLanguage] }}</button></p>
                              </div>
                          </div>
                  </div> 



                  <!-- ================================================================= -->
                  <!-- Section activation de la gestion de l'API client -->
                  <!-- ================================================================= --> 

                  <div v-if="false" class="block block-bordered">
                      <div class="block-header bg-gray-lighter">
                          <h2 class="block-title">{{ apiManagementSectionTitle[actualLanguage] }}</h2>
                      </div>
                      <div class="block-content">
                        <div class="row">
                          <div class="col-sm-12 col-md-9 col-lg-9 push">
                            <span class="h4 font-w400">{{apiManagementSectionText1[actualLanguage]}}</span>
                          </div>

                          <div class="col-sm-12 col-md-3 col-lg-3 push">
                            <label class="css-input switch switch-success">
                                <input @click="apiActivationChange()" type="checkbox" checked v-model="organizationData.apiManagement.apiActivationFlag"><span></span>
                                 <span class="h5 font-w400">{{ apiManagementActivationButton[actualLanguage] }}</span>
                            </label>
                          </div>

                          <div v-if="apiConfirmButtonDisplay" class="col-sm-3 col-md-3">
                              <p><button @click="apiActivationButtonSwitch()" type="button" class="btn btn-success align-center" name="button">{{ apiManagementActivationConfirmeButton[actualLanguage] }}</button></p>
                          </div>

                          <div class="col-sm-12 col-md-12 col-lg-12">
                            <span class="h6 font-w400">{{apiManagementSectionText2[actualLanguage]}}</span>
                          </div>

                        </div>

                      </div>
                  </div>


              </div>


              <!-- -------------------------------------- -->
              <!-- Message que l'abonnement prendra fin a la prochaine date de renouvellement -->
              <!-- -------------------------------------- -->
              <div v-if = "!organizationData.subscription.data.automaticRenewFlag" class="col-sm-12 col-md-12">

                <div class="col-sm-12 col-md-12">
                  <h3>{{messageSubscriptionEnding[actualLanguage]}}</h3>
                </div>
              </div>

              <!-- -------------------------------------- -->
              <!-- Message pour les renouvellement manuel par émission de facture par courriel -->
              <!-- -------------------------------------- -->
              <div v-if = "organizationData.subscription.data.automaticRenewFlag && !organizationData.subscription.data.preAuthorizedPaymentFlag" class="col-sm-12 col-md-12">

                <div v-if ="organizationData.subscription.data.paymentType=='ManuallyBilled'" class="col-sm-12 col-md-12">
                  <h3>{{manuallyBilledTitle[actualLanguage]}}</h3>
                </div>

                <div v-else class="col-sm-12 col-md-12">
                  <h3 class="push">{{activateManuallyBilledOptionMessage[actualLanguage]}}</h3>

                  <h3>{{activateManuallyBilledOptionMessage2[actualLanguage]}}</h3>
                </div>

              </div>




            </div>

            <div v-else class="col-sm-12 col-md-12">
              <h1>{{labelFreeService[actualLanguage]}}</h1>
            </div>


        </div>
    </div>


  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'

//RETRAIT STRIPE
//import StripePaiement from './StripePaiment'


export default {
  props: ['organizationData'],

  components: {
    //RETRAIT STRIPE
    //StripePaiement,
  },


  data() {
    return {
      
      actualLanguage : "FR",
      labelFreeService: {FR: 'Service gratuit', EN: 'Free service'},
      automaticRenewFlagInititalValue : false,
      preAuthorizedPaymentFlagInititalValue : false,
      renewFlagModified : false,

      buttonLabelAutomaticRenewal:{FR: "Poursuivre l'abonnement", EN: 'Continue subscription'},
      buttonLabelAutomaticPreAuthorizedPaiement:{FR: "Prélèvement automatique sur carte de crédit", EN: 'Credit card direct debit'},

      buttonLabelSaveModification:{FR: "Enregistrer les modifications", EN: 'Save modifications'},
      sectionLabelCreditCard:{FR: "Carte de crédit enregistrée", EN: 'Credit card recorded'},
      textLabelCardLastDigit:{FR: "Se terminant par...", EN: 'Ends by...'},
      buttonLabelModifyCard:{FR: "Modifier la carte de crédit", EN: 'Modify recorded card'},
      buttonLabelApplyCard:{FR: "Enregistrer une carte de crédit", EN: 'Apply a credit card'},
      textYouMustRegisterCreditCard :{FR: "Vous devez enregistrer une carte de crédit pour l'abonnement", EN: 'You must register a credit card for the subscription'},

      messageSubscriptionEnding:{FR: "Votre abonnement se terminera à la date de la prochaine facturation. Les licences d'utilisateur seront retirés automatiquement.",
                                 EN: 'Your subscription will end at the next billing date. All user licences will be removed automatically.'},

      manuallyBilledTitle:{FR: "Paiement par émission de facture par courriel.", EN: 'Payment by issuing an invoice by email.'},
      activateManuallyBilledOptionMessage:{FR: "Votre abonnement est de type qui nécessite un paiement par carte de crédit. Pour le convertir à facturation manuelle, contactez EV Sens.",
                                           EN: 'Your subscription is of the type that requires payment by credit card. To convert it to manual billing, contact EV Sens.'},

      activateManuallyBilledOptionMessage2:{FR: "Si vous enregistrez cette option sans que la conversion à facturation manuelle ait été activée, votre abonnement prendra fin à la date de la prochaine facturation.",
                                           EN: 'If you save this option without manual billing conversion enabled, your subscription will end on the next billing date.'},

      textLabelLastPaimentDate:{FR: "Date de la précédente facturation: ", EN: 'Date of previous billing:'},
      textLabelNextPaimentDate:{FR: "Date de la prochaine facturation: ", EN: 'Next billing date:'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

      apiManagementSectionTitle:{FR: "Control d'accès à l'API client EV Sens", EN: 'EV Sens Customer API Access control'},
      apiManagementSectionText1:{FR: "L'API EV Sens permet aux organisations qui développent leur propre appareils de mesure d'utiliser la plateforme EL-iot comme outil d'enregistrement des données. En activant l'API, la section Gestion API sera activé dans ce panneau de contrôle de l'organisation",
                               EN: 'The EV Sens API allows organizations developing their own measuring devices to use the EL-iot platform as a data logging tool. By activating the API, the API Management section will be activated in this organization control panel.'},
      apiManagementSectionText2:{FR: "L'API comporte des frais d'utilisation qui dépendent du taux d'utilisation de l'API. Ceci requiert une carte de crédit valide rattachée à l'abonnement de l'organisation. Les frais d'utilisation sont décrit dans la section Gestion API.",
                               EN: "The API as usage fees that depend on the API usage rate. This requires a valid credit card attached to the organization's subscription. User fees are described in the API Management section."},
      apiManagementActivationButton:{FR: "Activation", EN: 'Activation'},
      apiConfirmButtonDisplay : false,
      apiManagementActivationConfirmeButton:{FR: "Confirmer le changement", EN: 'Confirm the modification'},
      apiDesactivationMessage :{FR: "En désactivant le controle d'accès d'API, toutes les clefs d'API seront désactivée. Si des appareils effectuent de communications vers le cloud EV Sens, celles-ci seront bloquées.",
                                 EN: 'By disabling API access control, all API keys will be diseabled. If any devices make communications to the EV Sens cloud, they will be blocked.'},
      

    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    automaticRenewButtonSwitch(){
      if(this.organizationData.subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue || this.organizationData.subscription.data.preAuthorizedPaymentFlag == this.preAuthorizedPaymentFlagInititalValue){
          this.renewFlagModified = true
      }else{
          this.renewFlagModified = false
      }

      if (this.organizationData.subscription.data.automaticRenewFlag == true){
        this.organizationData.subscription.data.preAuthorizedPaymentFlag = false
      }
    },
      


    modifyMyAutomaticRenew(){
      this.automaticRenewFlagInititalValue=this.organizationData.subscription.data.automaticRenewFlag
      this.preAuthorizedPaymentFlagInititalValue = this.organizationData.subscription.data.preAuthorizedPaymentFlag
      this.renewFlagModified = false
      this.planTransactionData.organizationId = this.organizationData.organizationId
      this.planTransactionData.postAction = 'UpdateOrganizationAutomaticRenewFlag'
      this.planTransactionData.automaticRenewFlag = this.organizationData.subscription.data.automaticRenewFlag
      this.planTransactionData.preAuthorizedPaymentFlag = this.organizationData.subscription.data.preAuthorizedPaymentFlag

      
      this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData)
        .then((response) => {
          if(response.data.Code=='OK'){
            this.$store.dispatch('sessionStore/refreshProfileData')
            }
            else{
               window.alert(this.messagePostFail[this.actualLanguage])
            }
        })
    },

    modifyMyCreditCard(){
      this.planTransactionData.organizationId = this.organizationData.organizationId
      this.planTransactionData.postAction = 'ModifyOrganizationCreditCard'
      this.planTransactionData.buttonPay = {FR: "Modifier ma carte de crédit", EN: 'Modify my credit card'}
      //this.planTransactionData.transactionStatusCode = '100'
      
      //RETRAIT STRIPE
      //this.showModal('modify-stripe-paiement')
      
    },

    applyCreditCard(){
      this.planTransactionData.organizationId = this.organizationData.organizationId
      this.planTransactionData.postAction = 'ModifyOrganizationCreditCard'
      this.planTransactionData.buttonPay = {FR: "Appliquer cette carte", EN: 'Apply this card'}
      //this.planTransactionData.transactionStatusCode = '100'
      
      //RETRAIT STRIPE
      //this.showModal('modify-stripe-paiement')
      
    },

    apiActivationChange(){
      this.apiConfirmButtonDisplay = true

      if(this.organizationData.apiManagement.apiActivationFlag){
        window.alert(this.apiDesactivationMessage[this.actualLanguage])
      }
      

    },

    apiActivationButtonSwitch(){
         var requestData = { 'postAction':'SetApiManagement',
                            'organizationId': this.organizationData.organizationId,
                            'apiActivationFlag':this.organizationData.apiManagement.apiActivationFlag
                            }
        this.apiConfirmButtonDisplay = false

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Set API response------')
              //console.log(response.data)
            if(response.data.Code!='OK'){
                  window.alert(response.data.PromptMessage[this.actualLanguage])}
            })

    }



  
  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.automaticRenewFlagInititalValue = this.organizationData.subscription.data.automaticRenewFlag
    this.preAuthorizedPaymentFlagInititalValue = this.organizationData.subscription.data.preAuthorizedPaymentFlag

    //Affichage des données de l'organisation
    //console.log("DATA ORGANISATION")
    //console.log(this.organizationData)

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// OrganizationPaymentInfo.vue?39f60d04